import { AxiosResponse } from "axios";
import { coreAxios } from "./axios";
import { MeetingAttendee, MeetingMinute, MeetingOrganization, MeetingRecord, MeetingSummary } from "../interface/meeting";
import genUUID from "@/utils/gen-uuid";



/**
 * 上传携带音频的会议记录
 * @param file wav文件的Blob文件
 * @param fileName 文件的名字，你可以根据需要修改
 * @param params 
 * @returns 
 */
export function addMeetingRecordWithWav(file: Blob, meetingRecord: MeetingRecord, fileName?: string, params?: {}): Promise<AxiosResponse<number>> {
    // 创建一个 FormData 对象
    const formData = new FormData();
    formData.append('file', file, fileName ? fileName : genUUID() + ".wav");
    formData.append("json", JSON.stringify(meetingRecord));
    return coreAxios.post(`/meeting-records/wav`, formData, {
        params: {
            ...params,
        }
    })
}

export function submitMeetingRecordFile(recordId: number, pcmFile: Blob, wavFile: Blob, meetingRecord: MeetingRecord, params?: {}): Promise<AxiosResponse<number>> {
    // 创建一个 FormData 对象
    const formData = new FormData();
    formData.append('pcmFile', pcmFile, genUUID() + ".wav");
    formData.append('wavFile', wavFile, genUUID() + ".wav")
    // formData.append("json", JSON.stringify(meetingRecord));
    formData.append("json", new Blob([JSON.stringify(meetingRecord)], { type: "application/json" }));
    return coreAxios.put(`/meeting-minutes/meeting-records/${recordId}/files`, formData, {
        params: {
            ...params,
        }
    })
}

export function addMeetingRecord(meetingId: number, record: MeetingRecord, params?: {}): Promise<AxiosResponse<number>> {
    return coreAxios.post(`/meeting-minutes/${meetingId}/meeting-records`, record, {
        params: {
            ...params,
        }
    })
}


/**
 * 创建一个会议纪要
 * @param projectId 
 * @param meetingMinute 
 * @param params 
 * @returns 
 */
export function addMeetingMinute(projectId: number, meetingMinute: MeetingMinute, params?: {}): Promise<AxiosResponse<number>> {
    return coreAxios.post(`/projects/${projectId}/meeting-records`, meetingMinute, {
        params: {
            ...params,
        }
    })
}

/**
 * 获取一个项目下的所有会议纪要
 * @param projectId
 * @param params 
 * @returns 
 */
export function getMeetingMinutes(projectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}/meeting-records`, {
        params: {
            ...params,
        }
    })
}

export function deleteMeetingMinutes(meetingId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/meeting-minutes/${meetingId}`, {
        params: {
            ...params,
        }
    })
}

export function updateMeetingMainDetail(meetingId: number, data: MeetingMinute, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/meeting-minutes/${meetingId}`, data, {
        params: {
            ...params,
        }
    })
}

export function findMeetingListByProjectId(projectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}/meeting-minutes`, {
        params: {
            ...params,
        }
    })
}

export function findMeetingDetailById(meetingId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/meeting-minutes/${meetingId}`, {
        params: {
            ...params,
        }
    })
}
export function addMeetingOrganization(meetingId: number, data: MeetingOrganization, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/meeting-minutes/${meetingId}/orgs`, data, {
        params: {
            ...params,
        }
    })
}

export function updateMeetingOrganization(meetingOrgId: number, data: MeetingOrganization, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/meeting-orgs/${meetingOrgId}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteMeetingOrganization(meetingOrgId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/meeting-orgs/${meetingOrgId}`, {
        params: {
            ...params,
        }
    })
}
export function addMeetingAttendee(meetingId: number, meetingOrgId: number, data: MeetingAttendee, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/meeting-minutes/${meetingId}/meeting-orgs/${meetingOrgId}/attendees`, data, {
        params: {
            ...params,
        }
    })
}
export function deleteMeetingAttendee(attendeeId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/meeting-attendees/${attendeeId}`, {
        params: {
            ...params,
        }
    })
}
export function updateMeetingAttendee(attendeeId: number, data: MeetingAttendee, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/meeting-attendees/${attendeeId}`, data, {
        params: {
            ...params,
        }
    })
}
export function updateMeetingRecord(recordId: number, data: MeetingRecord, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/meeting-records/${recordId}`, data, {
        params: {
            ...params,
        }
    })
}
export function addMeetingSummary(meetingId: number, data: MeetingSummary, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/meeting-minutes/${meetingId}/meeting-summaries`, data, {
        params: {
            ...params,
        }
    })
}
export function updateMeetingSummary(summaryId: number, data: MeetingSummary, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/meeting-summaries/${summaryId}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteMeetingSummary(summaryId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/meeting-summaries/${summaryId}`, {
        params: {
            ...params,
        }
    })
}

/**
 * 结束会议
 * @param projectId
 * @param params 
 * @returns 
 */
export function endMeetingMinutes(meetingId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/meeting-records/${meetingId}/end`, {
        params: {
            ...params,
        }
    })
}

/**
 * 提交会议纪要
 * @param meetingId 
 * @param params 
 * @returns 
 */
export function submitMeetingMinutes(projectId: number, data: MeetingMinute, params?: {}): Promise<AxiosResponse<number>> {
    return coreAxios.post(`/projects/${projectId}/meeting-minutes/submit`, data, {
        params: {
            ...params,
        }
    })
}

export function exportMeetingWord(meetingId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/meeting-minutes/${meetingId}/export-word`, {}, {
        params: {
            ...params,
        }
    })
}
